export function CodeBlock({
  json,
  children,
  maxHeight,
  className,
}: {
  json?: any;
  children?: any;
  maxHeight?: string;
  className?: string;
}) {
  const style = maxHeight ? { maxHeight, overflow: 'auto' } : {};
  return (
    <pre
      className={`text-md mt-4 overflow-auto rounded-md bg-slate-50 p-3 font-mono text-muted ${className} `}
      style={style}
    >
      {children || JSON.stringify(json, null, 2)}
    </pre>
  );
}
